<template>
  <v-container class="blue-grey fill-height" :class="$vuetify.theme.dark ? 'darken-4' : 'lighten-3'" fluid grid-list-xs>
    <v-row align="center" justify="center">
      <v-col cols="12" md="6" sm="8" xl="4">
        <div class="text-center mb-4 mt-n8">
          <v-icon style="opacity: .8">mdi-robot-dead</v-icon>
        </div>
        <v-card>
          <v-card-text class="text-center">
            <div class="display-2 font-weight-bold">
              404
            </div>
            <br/>
            Die gesuchte Seite konnte im System nicht gefunden werden.
            Vergewissere dich, dass deine Eingabe korrekt war.
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="info" text @click="$router.go(-1)">
              <v-icon>mdi-chevron-left</v-icon>
              Zurück zur vorigen Seite
            </v-btn>
            <v-spacer/>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script lang="ts">
import Vue from 'vue';

export default Vue.extend();
</script>
